import React from 'react';
import Button from '@mui/material/Button';

export default function ShowButtonModule({data, style, extraProperties}) {
    return (
        <Button sx={style ? style : {}}>
            {data ? data : 'button'}
        </Button>
    )
}